// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2y_Mx","title":"Info_title__2mReX","selects":"Info_selects__3lDMv","requiredAsterisk":"Info_requiredAsterisk__3YNga"};